import api from '@/plugins/api'
import parser from '@/helpers/parser'
import ListSearch from '@/components/list-api-search'

const lang = document.documentElement.lang.replace('-', '_')

new ListSearch('.list-api-search', function(value) {
    return api('faq-articles', {
        data: {
            page: { size: 20 },
            include: ['translatedContent'],
            filter: { status: 'published' },
            search: value,
            filter_by_content: { lang },
            'translation-lang': lang
        },
    }).then(data => {
        let valueParsed = value.toLowerCase().trim()

        return data.data.map(article => {
            let label = document.createElement('span')
            let icon = document.createElement('i')

            icon.className = 'fa-regular fa-file-invoice mr-2 text-secondary'

            label.innerHTML = parser.highlightText(parser.entityHtml(article.translated_content.title), valueParsed)

            label.prepend(icon)

            return { value: article.id, label, link: `/faq/${article.translated_content.lang}/articles/${article.translated_content.slug}` }
        })
    })
})
